interface IInputFarmTraderOrganicInformation {
    inputFarmTraderOrganicInformationOrder: string;
    inputFarmScNo: string;
    inputFarmTcNo: string;
    inputTraderTcNoForOrganicMaterial: string;
    inputTcOrganicFarmStandards: string;
  }
  
  interface IInputTcProductStandardInformation {
    inputTcProductStandardInformationOrder: string;
    inputTcProductStandardLabelGrade: string;
    inputTcProductCertifiedWeight: number;
    inputTcProductCertifiedWeightUsed: number;
  }
  
  interface IInputProductRawMaterialInformation {
    inputProductRawMaterialInformationOrder: string;
    inputTcProductRawMaterialCode: string;
    inputTcProductRawMaterialPercentage: number;
  }
  
  interface IInputTcProductInformation {
    inputTcProductInformationOrder: string;
    inputTcProductNo: string;
    inputTcProductArticleNo: string;
    inputTcProductNumberOfUnits: number;
    inputTcProductUnitsMetric: string;
    inputTcProductProductionDate: string;
    inputTcProductCategoryCode: string;
    inputTcProductCategoryUserSpecificTerm: string;
    inputTcProductDetailCode: string;
    inputTcProductDetailUserSpecificTerm: string;
    inputTcProductInfoTrimsExcluded: string;
    inputTcProductInfoAssociatedTc: string;
    inputTcProductInfoFiberLength: string;
    inputTcProductInfoYarnCount: string;
    inputTcProductInfoFabricWeightAndConstruct: string;
    inputTcProductInfoFabricWeightOfFinishedProduct: string;
    inputTcProductInfoAdditional: string;
    etcMinimumWastageFactor: string;
    inputTcProductStandardInformation: IInputTcProductStandardInformation[];
    inputProductRawMaterialInformation: IInputProductRawMaterialInformation[];
  }
  
  interface IInputTcInformation {
    inputTcOrder: string;
    inputTcNo: string;
    tcAssociatedProductNo: string;
    inputTcCbLicensingCode: string;
    inputTcSellerLicenseNo: string;
    inputTcSellerTeId: string;
    inputTcSellerScNo: string;
    inputTcUsdaCompliantFlag: string;
    inputTcCertifiedWeightUsed: string;
    inputFarmTraderOrganicInformation: IInputFarmTraderOrganicInformation[];
    inputTcProductInformation: IInputTcProductInformation[];
  }
  
  interface ITcData {
    etcId: string;
    inputTcInformation: IInputTcInformation[];
  }
  

  export const mapPayload=(data:any[], etcId:any)=> {

    return {
        etcId: etcId,
        inputTcInformation: data.map((item,index )=> ({
            inputTcOrder: (index+1).toString(),
            inputTcNo: item.inputTcNo,
            tcAssociatedProductNo: item.inputTcProductNo,
            inputTcCbLicensingCode: "456", // Assuming this field is not present in input
            inputTcSellerLicenseNo: item.inputTcSellerLicenseNo,
            inputTcSellerTeId: item.inputTcSellerTeId,
            inputTcSellerScNo: item.inputTcSellerScNo,
            inputTcUsdaCompliantFlag: item.inputTcUsdaCompliance,
            inputTcCertifiedWeightUsed: item.inputTcCertifiedWeightUsed,
            inputFarmTraderOrganicInformation: item.inputFarmTraderOrganicInformation.map((proc:any) => ({
                inputFarmTraderOrganicInformationOrder: proc.inputFarmTraderOrganicInformationOrder.toString(),
                inputFarmScNo: proc.inputFarmSCNo,
                inputFarmTcNo: proc.inputFarmTCNo,
                inputTraderTcNoForOrganicMaterial: proc.inputTraderTCNoForOrganicMaterial,
                inputTcOrganicFarmStandards: proc.inputTCOrganicFarmStandards,
                additionalProp1: {}
            })),
            inputTcProductInformation: [
                {
                    inputTcProductInformationOrder:(index+1).toString(),
                    inputTcProductNo: item.inputTcProductInformation[0].inputTcProductNo,
                    inputTcProductArticleNo: item.inputTcProductInformation[0].inputTcProductArticleNo,
                    inputTcProductNumberOfUnits: parseInt(item.inputTcProductInformation[0].inputTcProductNumberOfUnits, 10),
                    inputTcProductUnitsMetric: item.inputTcProductInformation[0].inputTcProductUnitsMetric||'',
                    inputTcProductProductionDate: item.inputTcProductInformation[0].inputTcProductProductionDate,
                    inputTcProductCategoryCode: item.inputTcProductInformation[0].inputTcProductCategoryCode,
                    inputTcProductCategoryUserSpecificTerm: item.inputTcProductInformation[0].inputTcProductCategoryUserSpecificTerm,
                    inputTcProductDetailCode: item.inputTcProductInformation[0].inputTcProductDetailCode,
                    inputTcProductDetailUserSpecificTerm: item.inputTcProductInformation[0].inputTcProductDetailUserSpecificTerm,
                    inputTcProductInfoTrimsExcluded: item.inputTcProductInformation[0].inputTcProductInfoTrimsExcluded,
                    inputTcProductInfoAssociatedTc: item.inputTcProductInformation[0].inputTcProductInfoAssociatedTc,
                    inputTcProductInfoFiberLength: item.inputTcProductInformation[0].inputTcProductInfoFiberLength||'',
                    inputTcProductInfoYarnCount: item.inputTcProductInformation[0].inputTcProductInfoYarnCount||'',
                    inputTcProductInfoFabricWeightAndConstruct: item.inputTcProductInformation[0].inputTcProductInfoFabricWeightAndConstruct||'',
                    inputTcProductInfoFabricWeightOfFinishedProduct: item.inputTcProductInformation[0].inputTcProductInfoFabricWeightOfFinishedProduct||'',
                    inputTcProductInfoAdditional: item.inputTcProductInformation[0].inputTcProductInfoAdditional,
                    inputTcProductStandardInformation: item.inputTcProductInformation[0].inputTcProductStandardInformation.map((stdInfo:any,index:any) => ({
                        inputTcProductStandardInformationOrder: (index+1).toString(), // Assuming single order for each standard
                        inputTcProductStandardLabelGrade: stdInfo.inputTcProductStandardLabelGrade,
                        inputTcProductCertifiedWeight: parseFloat(stdInfo.inputTcProductCertifiedWeight),
                        inputTcProductCertifiedWeightUsed: parseFloat(stdInfo.inputTcProductCertifiedWeightUsed),
                        additionalProp1: {}
                    })),
                    inputProductRawMaterialInformation: item.inputTcProductInformation[0].inputProductRawMaterialInformation.map((rawMaterial:any) => ({
                        inputProductRawMaterialInformationOrder: rawMaterial.inputProductRawMaterialInformationOrder.toString(),
                        inputTcProductRawMaterialCode: rawMaterial.inputTcProductRawMaterialCode,
                        inputTcProductRawMaterialPercentage: parseFloat(rawMaterial.inputTcProductRawMaterialPercentage),
                        additionalProp1: {}
                    })),
                    additionalProp1: {}
                }
            ],
            additionalProp1: {}
        })),
        additionalProp1: {}
    };


}

export const reverseMapPayload = (payload: any) => {
    const { etcId, inputTcInformation } = payload;

    const data = inputTcInformation.map((inputItem: any) => ({
        tcProductComponentOrder: inputItem.inputTcOrder,
        inputTcNo: inputItem.inputTcNo,
        inputTcSellerLicenseNo: inputItem.inputTcSellerLicenseNo,
        inputTcSellerTeId: inputItem.inputTcSellerTeId,
        inputTcSellerScNo: inputItem.inputTcSellerScNo,
        inputTcUsdaCompliance: inputItem.inputTcUsdaCompliantFlag,
        inputTcCertifiedWeightUsed: inputItem.inputTcCertifiedWeightUsed,
        "input-tc-ocs-processor": inputItem.inputFarmTraderOrganicInformation.map((farmItem: any) => ({
            tcProductRawMaterialOrder: farmItem.inputFarmTraderOrganicInformationOrder,
            inputFarmSCNo: farmItem.inputFarmScNo,
            inputFarmTCNo: farmItem.inputFarmTcNo,
            inputTraderTCNoForOrganicMaterial: farmItem.inputTraderTcNoForOrganicMaterial,
            inputTCOrganicFarmStandards: farmItem.inputTcOrganicFarmStandards,
        })),
        inputTcProductNo: inputItem.inputTcProductInformation[0]?.inputTcProductNo,
        inputTcProductArticleNo: inputItem.inputTcProductInformation[0]?.inputTcProductArticleNo,
        inputTcProductNumberOfUnits: inputItem.inputTcProductInformation[0]?.inputTcProductNumberOfUnits,
        inputTcProductUnitsMetric: inputItem.inputTcProductInformation[0]?.inputTcProductUnitsMetric,
        inputTcProductProductionDate: inputItem.inputTcProductInformation[0]?.inputTcProductProductionDate,
        inputTcProductCategoryCode: inputItem.inputTcProductInformation[0]?.inputTcProductCategoryCode,
        inputTcProductCategoryUserSpecificTerm: inputItem.inputTcProductInformation[0]?.inputTcProductCategoryUserSpecificTerm,
        inputTcProductDetailCode: inputItem.inputTcProductInformation[0]?.inputTcProductDetailCode,
        inputTcProductDetailUserSpecificTerm: inputItem.inputTcProductInformation[0]?.inputTcProductDetailUserSpecificTerm,
        inputTcProductInfoTrimsExcluded: inputItem.inputTcProductInformation[0]?.inputTcProductInfoTrimsExcluded,
        inputTcProductInfoAssociatedTc: inputItem.inputTcProductInformation[0]?.inputTcProductInfoAssociatedTc,
        inputTcProductInfoFiberLength: inputItem.inputTcProductInformation[0]?.inputTcProductInfoFiberLength,
        inputTcProductInfoYarnCount: inputItem.inputTcProductInformation[0]?.inputTcProductInfoYarnCount,
        inputTcProductInfoFabricWeightAndConstruct: inputItem.inputTcProductInformation[0]?.inputTcProductInfoFabricWeightAndConstruct,
        inputTcProductInfoFabricWeightOfFinishedProduct: inputItem.inputTcProductInformation[0]?.inputTcProductInfoFabricWeightOfFinishedProduct,
        inputTcProductInfoAdditional: inputItem.inputTcProductInformation[0]?.inputTcProductInfoAdditional,
        "tc-std-info": inputItem.inputTcProductInformation[0]?.inputTcProductStandardInformation.map((stdItem: any) => ({
            standardLabelGrade: stdItem.inputTcProductStandardLabelGrade,
            certifiedWeight: stdItem.inputTcProductCertifiedWeight,
            certifiedWeightUsed: stdItem.inputTcProductCertifiedWeightUsed,
        })),
        "raw-materials-info": inputItem.inputTcProductInformation[0]?.inputProductRawMaterialInformation.map((rawItem: any) => ({
            tcProductRawMaterialOrder: rawItem.inputProductRawMaterialInformationOrder,
            tcProductRawMaterialCode: rawItem.inputTcProductRawMaterialCode,
            tcProductRawMaterialPercentage: rawItem.inputTcProductRawMaterialPercentage,
        })),
    }));

    return { etcId, data };
};
